import {FulfillmentEditor} from '@/containers/Fulfillment/FulfillmentEditor.jsx'
import {ImageOptimization} from '@/containers/ImageOptimization'
import {useGrowthBookFeatureFlags} from '@/hooks/use-growthbook-feature-flags-hook'
import {
  PageError404,
  TestPage,
} from '@/pages'
import ProductCatalogByMarket from '@/pages/Content/ProductCatalogByMarket'
import {PageError403} from '@/pages/Errors/403'
import {PageError500} from '@/pages/Errors/500'
import {Login} from '@/pages/Login'
import {PromotionEditor} from '@/pages/Promotions/CreatePromotion/PromotionEditor'
import {PromotionDetailEditor} from '@/pages/Promotions/PromotionDetail/PromotionDetailEditor.jsx'
import {SelectPromotionTypeEditor} from '@/pages/Promotions/SelectPromotionType/SelectPromotionTypeEditor'
import {ComboDetail} from '@/pages/ProductCombo/ComboDetail/ComboDetail'
import {ProductComboEditor} from '@/pages/ProductCombo/ProductComboEditor'
import ProductListByMarket from '@/pages/ProductListByMarket'
import ProductReview from '@/pages/ProductReview'
import ProductReviewEdit from '@/pages/ProductReviewEdit'
import PromotionListByMarket from '@/pages/PromotionListByMarket'
import {useAppDispatch} from '@/store'
import {setShellActive, setShellPath} from '@/store/slices/commonSlice'
import {setCountryCode} from '@/store/slices/countryCodeSlice'
import {ROUTES} from '@/utils/constants/routesConstants'
import {GrowthBookProvider} from '@growthbook/growthbook-react'
import {useEffect} from 'react'
import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import {ProtectedRoutes} from './ProtectedRoutes'
import { Logout } from '@/pages/Logout'

const productRoutes = [
  {path: ROUTES.PRODUCTS_LIST, element: <ProductListByMarket />},
  {path: ROUTES.PRODUCT_REVIEW, element: <ProductReview />},
  {path: ROUTES.PRODUCT_REVIEW_EDIT, element: <ProductReviewEdit />},
]

const promotionsRoutes = [
  {
    path: ROUTES.CREATE_PROMOTION,
    element: <PromotionEditor />,
  },

  {path: ROUTES.PROMOTION_DETAIL, element: <PromotionDetailEditor />},
  {path: ROUTES.PROMOTIONS_LIST, element: <PromotionListByMarket />},
  {path: ROUTES.SELECT_PROMOTION_TYPE, element: <SelectPromotionTypeEditor />},

  {path: ROUTES.PROMOTIONS_LIST_ALIAS, element: <PromotionListByMarket />},
  {path: ROUTES.CREATE_PROMOTION_ALIAS, element: <SelectPromotionTypeEditor />},
]

const productCombinationRoutes = [
  {
    path: ROUTES.CREATE_PRODUCT_COMBINATION,
    element: <ProductComboEditor />,
  },
  {path: ROUTES.PRODUCT_COMBO_DETAIL, element: <ComboDetail />},
]

const contentRoutes = [{path: ROUTES.PRODUCT_CATALOG, element: <ProductCatalogByMarket />}]

const imageRoutes = [{path: ROUTES.IMAGE, element: <ImageOptimization />}]

const fulfillmentRoutes = [
  {path: ROUTES.FULFILLMENT, element: <FulfillmentEditor />},
  {path: ROUTES.INVENTORY, element: <FulfillmentEditor />},
]
const router = createBrowserRouter([
  {path: ROUTES.LOGIN, element: <Login />},
  {
    element: <ProtectedRoutes />,
    children: [
      {path: ROUTES.LOGOUT, element: <Logout />},
      {path: ROUTES.HOME, element: <ProductListByMarket />},
      ...productRoutes,
      ...imageRoutes,
      ...promotionsRoutes,
      ...fulfillmentRoutes,
      ...productCombinationRoutes,
      ...contentRoutes,

      /* Errors */
      {path: ROUTES.ERROR_500, element: <PageError500 />},
      {path: ROUTES.ERROR_403, element: <PageError403 />},
      {path: '*', element: <PageError404 />},

      /* Test */
      {path: ROUTES.TEST, element: <TestPage />},
    ],
  },
])

export const AppRouter = ({shellActive, path, market = import.meta.env.VITE_COUNTRY_CODE,config}) => {
  const dispatch = useAppDispatch()
  const {growthbook} = useGrowthBookFeatureFlags()

  useEffect(() => {
    dispatch(setShellActive(shellActive))
  }, [shellActive, dispatch])

 

  // expected everytime to dispatch the shell path when component is mounted to navigate properly
  useEffect(() => {
    dispatch(setShellPath(path))
  }) //do not add dependency

  useEffect(() => {
    if (market) {
      sessionStorage.setItem('countryCode', market)
      dispatch(setCountryCode(market))
    }
  }, [dispatch, market])

  return (
    <GrowthBookProvider key={market || 'default'} growthbook={growthbook}>
      <RouterProvider router={router} />
    </GrowthBookProvider>
  )
}
